import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-master-reports',
  templateUrl: './master-reports.component.html',
  styleUrls: ['./master-reports.component.css']
})
export class MasterReportsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/hrms/payroll/payroll-reports/master-reports/master-reports.component.ts